import { RegionalFreePeriodEligibility } from '../api/Api';

export type PlacementPricingMode = 'loading' | 'error' | 'regional' | 'office_promotion' | 'standard';

export function resolvePlacementPricingMode({
    loading,
    error,
    eligibility,
    officePromotionEligible,
}: {
    loading: boolean;
    error: boolean;
    eligibility: RegionalFreePeriodEligibility | null;
    officePromotionEligible: boolean;
}): PlacementPricingMode {
    if (loading) return 'loading';
    if (error) return 'error';
    if (eligibility?.campaignId && (
        eligibility.eligible || eligibility.reason === 'reference_date_required'
    )) return 'regional';
    if (officePromotionEligible) return 'office_promotion';
    return 'standard';
}
